if($('#gmap').length) {
    window.GMAP = {
        data: {
            options_gmap_cluster: {}
        },

        init: async () => {

            /*console.log('IN --- INIT GMAP');
            console.log(typeof window.can_use_apple_map);
            console.log(typeof window.mapbox_api);
            console.log(typeof window.apple_map_api);

            if(typeof window.can_use_apple_map != 'undefined' && window.can_use_apple_map == true && typeof window.apple_map_api != 'undefined') {

                console.log('apple map init');

            } else if(typeof window.mapbox_api != 'undefined') {

                console.log('mapbox init');

                mapboxgl.accessToken = window.mapbox_api;
                var map = new mapboxgl.Map({
                  container: 'gmap',
                  style: 'mapbox://styles/chargerenergy/cma5b3qd7004401r44l52brhc',
                  center: [window.map_center.lng, window.map_center.lat],
                  zoom: 9
                });



               /!*map.on('load', () => {
                    map.addSource('chargers', {
                        type: 'geojson',
                        data: {
                            type: 'FeatureCollection',
                            features: window.chargers
                        },
                        cluster: true,
                        clusterMaxZoom: 14,
                        clusterRadius: 50
                    });

                    map.addLayer({
                        id: 'clusters',
                        type: 'circle',
                        source: 'chargers',
                        filter: ['has', 'point_count'],
                        paint: {
                            'circle-color': '#0e9a68',
                            'circle-radius': [
                                'step',
                                ['get', 'point_count'],
                                15, 10,
                                20, 30,
                                25
                            ],
                            'circle-stroke-width': 1,
                            'circle-stroke-color': '#fff',
                        }
                    });

                    map.addLayer({
                        id: 'cluster-count',
                        type: 'symbol',
                        source: 'chargers',
                        filter: ['has', 'point_count'],
                        layout: {
                            'text-field': '{point_count_abbreviated}',
                            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                            'text-size': 12
                        },
                        paint: {
                            'text-color': '#ffffff'
                        }
                    });

                   map.addLayer({
                        id: 'unclustered-point',
                        type: 'circle',
                        source: 'chargers',
                        filter: ['!', ['has', 'point_count']],
                        paint: {
                            'circle-color': [
                                'match',
                                ['get', 'status'],
                                'online', '#0e9a68',
                                'offline', '#ff4d4f',
                                'repair', '#0e669a',
                                '#999999'
                            ],
                            'circle-radius': 6,
                            'circle-stroke-width': 1,
                            'circle-stroke-color': '#fff'
                        }
                    });


                    map.on('click', 'unclustered-point', (e) => {
                        const url = e.features[0].properties.url;

                        if (url) {
                            window.open(url, '_blank'); // Открывает ссылку в новой вкладке
                        }
                    });

                    map.on('click', 'clusters', (e) => {
                        const features = map.queryRenderedFeatures(e.point, { layers: ['clusters'] });
                        const clusterId = features[0].properties.cluster_id;
                        map.getSource('chargers').getClusterExpansionZoom(clusterId, (err, zoom) => {
                            if (err) return;
                            map.easeTo({
                                center: features[0].geometry.coordinates,
                                zoom: zoom
                            });
                        });
                    });

                    map.on('mouseenter', 'clusters', () => {
                        map.getCanvas().style.cursor = 'pointer';
                    });
                    map.on('mouseleave', 'clusters', () => {
                        map.getCanvas().style.cursor = '';
                    });
                });*!/
            }*/

            if(typeof google != 'undefined') {
                var map_style = [
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dde2e3"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#c6e8b3"
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#c6e8b3"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#c1d1d6"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#a9b8bd"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f8fbfc"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "color": "#979a9c"
                            },
                            {
                                "visibility": "on"
                            },
                            {
                                "weight": 0.5
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#827e7e"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#3b3c3c"
                            },
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.airport",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.bus",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.rail",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#a6cbe3"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    }
                ];


                /* dark */
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    map_style = [
                        {
                            "stylers": [
                                {
                                    "hue": "#ff1a00"
                                },
                                {
                                    "invert_lightness": true
                                },
                                {
                                    "saturation": -100
                                },
                                {
                                    "lightness": 33
                                },
                                {
                                    "gamma": 0.5
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#2D333C"
                                }
                            ]
                        }
                    ];
                }

                window.gmap = new google.maps.Map(document.getElementById('gmap'), {
                    zoom: 10,
                    maxZoom: 8,
                    center: window.map_center,
                    gestureHandling: 'greedy',
                    disableDefaultUI: true,
                    styles: map_style
                });
                window.gmap.setOptions({minZoom: 4, maxZoom: 30});


                ///////////////////////////////////////////////////

                var getGoogleClusterInlineSvg = function(color) {
                    var encoded = window.btoa('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" enable-background="new 0 0 200 200"><path d="m99.5 187.5c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88" fill="#fff"/><path d="M99.5,20c43.8,0,79.5,35.7,79.5,79.5S143.3,179,99.5,179S20,143.3,20,99.5S55.7,20,99.5,20 M99.5,3C46.2,3,3,46.2,3,99.5S46.2,196,99.5,196S196,152.8,196,99.5S152.8,3,99.5,3L99.5,3z" fill="'+color+'"/></svg>');
                    return ('data:image/svg+xml;base64,' + encoded);
                };


                window.GMAP.data.options_gmap_cluster = {
                    /*gridSize: 200,*/
                    styles: [
                        {
                            width: 40,
                            height: 40,
                            url: getGoogleClusterInlineSvg(window.main_color),
                            textColor: window.main_color,
                            textSize: 12
                        },
                        {
                            width: 50,
                            height: 50,
                            url:  getGoogleClusterInlineSvg(window.main_color),
                            textColor: window.main_color,
                            textSize: 14
                        },
                        {
                            width: 60,
                            height: 60,
                            url:  getGoogleClusterInlineSvg(window.main_color),
                            textColor: window.main_color,
                            textSize: 16
                        },
                        {
                            width: 70,
                            height: 70,
                            url:  getGoogleClusterInlineSvg(window.main_color),
                            textColor: window.main_color,
                            textSize: 18
                        },
                        {
                            width: 80,
                            height: 80,
                            url:  getGoogleClusterInlineSvg(window.main_color),
                            textColor: window.main_color,
                            textSize: 20
                        }
                    ]
                };

                window.WS.getMapChargers();
            }
        },

        parseGmapMarkers: async (chargers) => {

            if(typeof window.markers != 'undefined') {
                $.each(window.markers, function (index, marker) {
                    window.markers[index].setMap(null);
                });

                if(typeof window.markerCluster != 'undefined') {
                    window.markerCluster.clearMarkers();
                }
            }

            window.markers = [];


            $.each(chargers, function (index, charger) {
                if(typeof google != 'undefined') {
                    switch (charger.status) {
                        case "offline":
                            var icon = {
                                url: window.gmap_img.charger_offline,
                                scaledSize: new google.maps.Size(50, 50),
                                origin: new google.maps.Point(0, 0)
                            };
                            break;
                        case "repair":
                            var icon = {
                                url: window.gmap_img.charger_repair,
                                scaledSize: new google.maps.Size(50, 50),
                                origin: new google.maps.Point(0, 0)
                            };
                            break;
                        default:
                            var icon = {
                                url: window.gmap_img.charger,
                                scaledSize: new google.maps.Size(50, 50),
                                origin: new google.maps.Point(0, 0)
                            };
                            break;
                    }

                    var marker = new google.maps.Marker({
                        position: {
                            'lat': parseFloat(charger.location.lat),
                            'lng': parseFloat(charger.location.lng)
                        },
                        map: window.gmap,
                        icon: icon,
                        pk: charger.pk,
                        connectors_count: charger.connectors_count,
                        gps: {
                            lat: parseFloat(charger.location.lat),
                            lng: parseFloat(charger.location.lng)
                        },
                        draggable: false
                    });

                    marker.addListener('click', function () {
                        window.CHARGER.open_window(marker.pk);
                    });

                    window.markers.push(marker);
                }
            });

            if (window.markers.length > 0) {
                window.markerCluster = new MarkerClusterer(window.gmap, window.markers, window.GMAP.data.options_gmap_cluster);

                window.markerCluster.setCalculator(function (markers, numStyles) {
                    var index = 0,
                        count = markers.length,
                        total = count;

                    while (total !== 0) {
                        total = parseInt(total / 5, 10);
                        index++;
                    }

                    var connectors = 0;
                    $.each(markers, function (index, value) {
                        connectors += value.connectors_count;
                    });

                    index = Math.min(index, numStyles);

                    return {
                        text: connectors,
                        index: index
                    };
                });
            }
        }
    };

    /*window.GMAP.init();*/



        ///////////////////////////////////////////////////

        window.GMAP_USER = {
            fields: {
                icon: {
                    img: window.gmap_img.user,
                    size: {
                        w: 20,
                        h: 20
                    }
                },
                user_geo: {
                    lan: 0,
                    lng: 0
                },
                current_location_btn: $('.current-location-btn'),
                user_position_marker: false
            },

            show_curreent_location_btn: async () => {
            if(!window.GMAP_USER.fields.current_location_btn.hasClass('active')) {
            window.GMAP_USER.fields.current_location_btn.click(function () {
                window.GMAP_USER.set_center();
            });

            window.GMAP_USER.fields.current_location_btn.addClass('active');
        }
    },

        update_position: async () => {

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {

                    if (typeof google != 'undefined') {

                        window.GMAP_USER.fields.user_geo.lan = position.coords.latitude;
                        window.GMAP_USER.fields.user_geo.lng = position.coords.longitude;

                        if(window.GMAP_USER.fields.user_position_marker == false) {

                            var icon = {
                                url: window.GMAP_USER.fields.icon.img,
                                scaledSize: new google.maps.Size(GMAP_USER.fields.icon.size.w, GMAP_USER.fields.icon.size.h),
                                origin: new google.maps.Point(0, 0),
                                anchor: new google.maps.Point(0, 0)
                            };

                            window.GMAP_USER.fields.user_position_marker = new google.maps.Marker({
                                position: {
                                    'lat': window.GMAP_USER.fields.user_geo.lan,
                                    'lng': window.GMAP_USER.fields.user_geo.lng
                                },
                                map: window.gmap,
                                connectors: 0,
                                icon: icon,
                                draggable: false
                            });
                        } else {

                            var newLatLng = new google.maps.LatLng(window.GMAP_USER.fields.user_geo.lan, window.GMAP_USER.fields.user_geo.lng);
                            window.GMAP_USER.fields.user_position_marker.setPosition(newLatLng);
                        }

                        window.GMAP_USER.set_center();
                        window.GMAP_USER.show_curreent_location_btn();
                    }
                });

                if (typeof navigator.permissions != 'undefined') {
                    navigator.permissions.query({name: 'geolocation'}).then(function (result) {
                        switch (result.state) {
                            case "granted":
                                if (typeof window.GMAP_USER_INTERVAL != 'undefined') {
                                    clearTimeout(window.GMAP_USER_INTERVAL);
                                }
                                break;
                            case "denied":
                                if (typeof window.GMAP_USER_INTERVAL != 'undefined') {
                                    clearTimeout(window.GMAP_USER_INTERVAL);
                                }

                                if(window.GMAP_USER.fields.current_location_btn.hasClass('active')) {
                                    window.GMAP_USER.fields.current_location_btn.removeClass('active');
                                }
                                break;
                            case "prompt":
                                if (typeof window.GMAP_USER_INTERVAL == 'undefined') {
                                    window.GMAP_USER_INTERVAL = setInterval(function () {
                                        window.GMAP_USER.update_position();
                                    }, 1000);
                                }
                                break;
                            default:
                                if (typeof window.GMAP_USER_INTERVAL != 'undefined') {
                                    clearTimeout(window.GMAP_USER_INTERVAL);
                                }

                                if(window.GMAP_USER.fields.current_location_btn.hasClass('active')) {
                                    window.GMAP_USER.fields.current_location_btn.removeClass('active');
                                }
                                break;
                        }
                    });
                }
            }
        },

        set_center: async () => {
            if(typeof window.gmap  != 'undefined' && typeof google != 'undefined'&& typeof window.gmap.setCenter != 'undefined') {
                window.gmap.setCenter(new google.maps.LatLng(window.GMAP_USER.fields.user_geo.lan, window.GMAP_USER.fields.user_geo.lng));
                window.gmap.setZoom(18);
            }
        },

        init: async () => {
            if(navigator.geolocation) {} else {
                if(window.GMAP_USER.fields.current_location_btn.hasClass('active')) {
                    window.GMAP_USER.fields.current_location_btn.removeClass('active');
                }
            }

            window.GMAP_USER.fields.current_location_btn.click(function () {
                window.GMAP_USER.update_position();
            });
        },
    };
    window.GMAP_USER.init();
}

window.GMAP_FILTER = {
    layer: {
        filter_btn: $(".filter-btn"),
        filter_window: $('#filter-layer'),
        filter_cross: $('#filter-layer .filter-layer-title .cross'),
        filter_item: $('#filter-layer .filter-layer-content .item'),
        to_map_btn:  $('#filter-layer .filter-layer-content .go-to-map button')
    },

    init: async () => {
        window.GMAP_FILTER.layer.filter_btn.click(function () {
            if(!window.GMAP_FILTER.layer.filter_window.hasClass('active')) {
                window.GMAP_FILTER.layer.filter_window.addClass('active');
            }
        });

        window.GMAP_FILTER.layer.to_map_btn.click(function () {
            if(window.GMAP_FILTER.layer.filter_window.hasClass('active')) {
                window.GMAP_FILTER.layer.filter_window.removeClass('active');
            }
        });

        window.GMAP_FILTER.layer.filter_cross.click(function () {
            if(window.GMAP_FILTER.layer.filter_window.hasClass('active')) {
                window.GMAP_FILTER.layer.filter_window.removeClass('active');
            }
        });

        window.GMAP_FILTER.layer.filter_item.click(function () {
            var key = $(this).attr('data-key');

            var filter = $.cookie('filter');
            filter = atob(filter);
            filter = JSON.parse(filter);

            var filter_change = false;


            if($(this).hasClass('active')) {
                $(this).removeClass('active');

                if(filter[key] == 1) {
                    filter[key] = 0;
                    filter_change = true;
                }
            } else {
                $(this).addClass('active');

                if(filter[key] == 0) {
                    filter[key] = 1;
                    filter_change = true;
                }
            }

            if(filter_change) {
                filter = JSON.stringify(filter);
                filter = btoa(filter);
                $.cookie('filter', filter, { expires: 1825, path: '/', domain: window.domain_in, secure: true });
                window.WS.getMapChargers();
            }
        });
    }
};

window.GMAP_FILTER.init();


window.referral = {
    check_get: function () {

        var referral = window.getUrlParameter('referral');
        var referral_coockie = $.cookie('referral');

        if(referral != false && typeof referral_coockie == 'undefined') {
            $.cookie('referral', referral, { expires: 1825, path: '/', domain: window.domain_in, secure: true });
        }
    }
};
window.referral.check_get();

window.get_url_domain = function(data) {
    var    a      = document.createElement('a');
    a.href = data;
    return a.hostname;
}

window.source = {
    check_get: function () {

        var utm_source = window.getUrlParameter('utm_source');
        var utm_source_coockie = $.cookie('utm_source');

        if(utm_source != false && typeof utm_source_coockie == 'undefined') {

            $.cookie('utm_source', utm_source, { expires: 1825, path: '/', domain: window.domain_in, secure: true });

        } else if(utm_source == false && typeof utm_source_coockie == 'undefined') {

            if(document.referrer != '') {
                var domain = window.get_url_domain(document.referrer);
                $.cookie('utm_source', domain, { expires: 1825, path: '/', domain: window.domain_in, secure: true });
            }
        }
    }
};
window.source.check_get();
